import React, { useState, useEffect } from 'react';
import OrderService from '../services/OrderService';

import dine_in from '../images/dine-in.svg';
import delivery from '../images/delivery.svg';
import takeway from '../images/take-away.svg';

import ready from '../images/food-ready.svg';
import placed from '../images/food-placed.svg';
import served from '../images/food-served.svg';

import table from '../images/table.svg';
import bill from '../images/bill.svg';
import prepare from '../images/prepare.svg';
import assistance from '../images/assitance.gif';
import request_item from '../images/request.gif';

import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';

<style>
    {`
  @keyframes zoomPulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.15); }
    100% { transform: scale(1); }
  }
`}
</style>

const OrderCard = ({ order }) => {
    // Timer Logic
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const target = new Date(order.targetCompletionTime);
            const diffInSeconds = Math.floor((target - now) / 1000);
            return diffInSeconds; // Can be negative if overdue
        };

        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
            setTimeLeft(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [order.targetCompletionTime]);

    const formatTime = (seconds) => {
        const absSeconds = Math.abs(seconds);
        const mins = Math.floor(absSeconds / 60).toString().padStart(2, '0');
        const secs = (absSeconds % 60).toString().padStart(2, '0');
        return `${seconds < 0 ? '-' : ''}${mins}:${secs}`;
    };

    const getStatusTag = (seconds) => {
        if (seconds <= 60 && seconds > -60) {
            return { text: 'Delay', className: 'delay_tag' };
        } else if (seconds <= 120 && seconds > 60) {
            return { text: 'Slight Delay', className: 'slight_delay_tag' };
        } else if (seconds > 120) {
            return { text: 'On Time', className: 'on_time_tag' };
        } else {
            return { text: 'Delay', className: 'delay_tag' }; // Changed from 'Late' to 'Delay' as per spec
        }
    };

    const getTextStyle = (seconds) => {
        if (seconds <= 60) {
            return {
                color: '#D22633',
                animation: 'zoomPulse 1s infinite',
            };
        } else if (seconds <= 120) {
            return { color: '#FF933C' };
        } else {
            return { color: '#000000' };
        }
    }


    const getOrderTypeIcon = (type) => {
        switch (type) {
            case 'DINE_IN': return dine_in;
            case 'DELIVERY': return delivery;
            case 'TAKE_AWAY': return takeway;
            default: return dine_in;
        }
    };

    const getStatusInfo = (status) => {
        switch (status) {
            case 'PLACED': return { icon: placed, text: 'PLACED', progress: 25 };
            case 'PREPARING': return { icon: prepare, text: 'PREPARING', progress: 50 };
            case 'READY': return { icon: ready, text: 'READY', progress: 75 };
            default: return { icon: placed, text: status, progress: 0 };
        }
    };

    const statusInfo = getStatusInfo(order.status);
    const timeStatus = getStatusTag(timeLeft);


    return (
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
            <div className={`white_bg_color rounded mb-4 item_box ${timeLeft <= 60 ? 'error_bg_flash' : ''}`}>

                {/* date time and food delivery */}
                <div className="border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="mb-0">
                        {/* Parse and format placedAt */}
                        <p className='ex_small_text mb-0'>{new Date(order.placedAt).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase().replace(',', ' |')}</p>
                    </div>

                    <div className="mb-0">
                        <p className='small_text mb-0'>{order.orderType?.replace('_', '-')} <img src={getOrderTypeIcon(order.orderType)} alt='' className='ms-2' style={{ width: '35px' }}></img></p>
                    </div>
                </div>
                {/* date time and food delivery */}

                <div className="clearfix"></div>

                {/* table and bill no */}
                <div className="border-bottom d-flex justify-content-between align-items-center no_box" style={{ backgroundColor: '#EAEAEA' }}>

                    <div className="col px-3 py-2 d-flex align-items-center border_end">
                        <div className="text-center me-2">
                            <img src={table} alt='' style={{ width: '40px' }}></img>
                            <p className='ex_small_text mb-0'>&nbsp;</p>
                        </div>

                        <div className="div">
                            <p className='orange_text mb-0'>Table No</p>
                            <h1 className='heading fw-bold mb-0'>{order.tableNo || '--'}</h1>
                        </div>
                    </div>

                    <div className="col px-3 py-2 d-flex align-items-center">
                        <div className="text-center me-2">
                            <img src={bill} alt='' className='me-2' style={{ width: '40px' }}></img>
                        </div>

                        <div className="div">
                            <p className='orange_text mb-0'>Bill No</p>
                            <h1 className='heading fw-bold mb-0'>{order.billNo}</h1>
                        </div>

                    </div>
                </div>
                {/* table and bill no */}

                <div className="clearfix"></div>

                {/* order status */}
                <div className="border-bottom d-flex justify-content-between align-items-center item_status_box">

                    <div className="col p-3 d-flex align-items-center border-end">
                        <div className="text-center me-2">
                            <img src={statusInfo.icon} alt='' style={{ width: '70px', height: '70px' }}></img>
                        </div>

                        <div className="div">
                            {/* Dynamic class for tag could be improved, mostly follows lowercase convention */}
                            <p className={`${statusInfo.text.toLowerCase()}_tag mb-0`}>{statusInfo.text}</p>
                        </div>
                    </div>

                    <div className="col p-3 d-flex align-items-center text-center">

                        <div className="w-100">
                            <h1 className='heading fw-bold mb-0 roboto_consended'>{statusInfo.progress}%</h1>
                            <div className="progress" style={{ height: '8px' }}>
                                <div className="progress-bar bg_orange" role="progressbar" style={{ width: `${statusInfo.progress}%`, height: '8px' }} aria-valuenow={statusInfo.progress} aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* order status */}

                <div className="clearfix"></div>

                {/* order timing */}
                <div className="d-flex justify-content-between align-items-center order_timer_box">

                    <div className="col p-3 d-flex align-items-center">
                        {order.customerRequest === 'ASSISTANCE' && (
                            <>
                                <div className="text-center me-2">
                                    <img src={assistance} alt='' style={{ width: '50px' }}></img>
                                </div>
                                <div className="div">
                                    <h1 className='sub_heading mb-0'>Get Assistance</h1>
                                </div>
                            </>
                        )}
                        {order.customerRequest === 'ITEM' && (
                            <>
                                <div className="text-center me-2">
                                    <img src={request_item} alt='' style={{ width: '50px' }}></img>
                                </div>
                                <div className="div">
                                    <h1 className='sub_heading mb-0'>Request Item</h1>
                                </div>
                            </>
                        )}
                        {!order.customerRequest && <span>&nbsp;</span>}
                    </div>

                    <div className="col p-3 d-flex align-items-center timing_box ms-auto">
                        <div className="text-center me-2 border-end pe-2">
                            <p className={`mb-0 ${timeStatus.className}`}>{timeStatus.text}</p>
                            <h1 className='sub_heading fw-bold mb-0' style={{ fontSize: '25px' }}>10:00</h1>
                        </div>

                        <div className="div">
                            <h1 className='heading fw-bold mb-0' style={getTextStyle(timeLeft)}>{formatTime(timeLeft)}</h1>
                        </div>

                    </div>
                </div>
                {/* order timing */}

            </div>
        </div>
    );
};


export default function Landing() {
    const [selectedOption, setSelectedOption] = useState('All');
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const data = await OrderService.getOrders('ongoing', selectedOption);
            setOrders(data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
        const interval = setInterval(fetchOrders, 30000); // Polling every 30s
        return () => clearInterval(interval);
    }, [selectedOption]);


    const handleSelect = (option) => {
        setSelectedOption(option);
    };

    return (
        <div className="inner_body">
            <PageHeader />

            <div className="container-fluid">
                <div className="row m-auto">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <h1 className="sub_heading">Orders | Ongoing</h1>
                    </div>

                    {/* filter dowpdown */}
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-end">
                        <div className="dropdown">
                            <button className="btn btn-light dropdown-toggle text-start border" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ width: '180px' }}>
                                <i className="fa-solid fa-sliders"></i> &nbsp; {selectedOption}
                            </button>

                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                {['All', 'Dine-In', 'Delivery', 'Take Away'].map((option) => (
                                    <li key={option}>
                                        <button className="dropdown-item" onClick={() => handleSelect(option)}>
                                            {option}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* filter dowpdown */}

                    <div className="clearfix"></div>
                </div>
            </div>

            {/* ================== */}
            {/* ================== */}

            {/* card section */}
            <div className="container-fluid mt-3 mb-5">
                <div className="row m-auto">
                    {loading && <p>Loading orders...</p>}
                    {!loading && orders.length === 0 && <p>No ongoing orders found.</p>}

                    {orders.map(order => (
                        <OrderCard key={order.id} order={order} />
                    ))}

                </div>
            </div>

            {/* floating btn */}
            <a href='/served'>
                <div className="floating_btn">
                    <div className="d-flex justify-content-center align-items-center flex-wrap">
                        <img src={served} alt='' style={{ width: '40px' }}></img>
                        <p className='fw-bold mb-0'>SERVED</p>
                    </div>
                </div>
            </a>
            {/* floating btn */}

            <Footer />
        </div>
    );
}
